import * as login from './login';
import * as user from './user';
import * as lesson from './lesson';
import * as group from './group';

// eslint-disable-next-line
export default {
    ...user,
    ...login,
    ...lesson,
    ...group
}